import { styled } from '../../Utilities';
import { GridBase } from './Grid.base';
import { getStyles } from './Grid.styles';
export var Grid = styled(GridBase, getStyles);
//# sourceMappingURL=Grid.js.map